import { useState } from "react";

import useSetTimeout from "app/pages/sales-intelligence/hooks/useSetTimeout";

const DEFAULT_TIMEOUT = 2000;

function useDummyLoading(time = DEFAULT_TIMEOUT): [boolean, VoidFunction] {
    const [isLoading, setIsLoading] = useState(false);

    const timeout = useSetTimeout();

    return [
        isLoading,
        () => {
            setIsLoading(true);

            timeout(() => setIsLoading(false), time);
        },
    ];
}

export default useDummyLoading;
